import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './services/auth/guards/auth.guard';
import { CreatePasswordComponent } from './layouts/create-password/create-password.component';
import { InviteUserComponent } from './layouts/invite-user/invite-user.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./layouts/layout-auth/layout-auth.module').then(
        (m) => m.LayoutAuthModule,
      ),
  },
  { path: 'create-password', component: CreatePasswordComponent },
  // { path: 'invite', component: InviteUserComponent },
  {
    path: 'invite',
    loadChildren: () =>
      import('./layouts/invite-user/invite-user.module').then(
        (m) => m.InviteUserModule,
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./layouts/layout-navigation/layout-navigation.module').then(
        (m) => m.LayoutNavigationModule,
      ),
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '/auth', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
